import { IconButton } from "@mui/material"
import { Settings } from "@mui/icons-material"
import { useDispatch, useSelector } from "react-redux"
import { setSettingsWindowVisible } from "../../actions/userSettingsActions";
import { anyLongDisablingProcess } from "../../reducers/disablingProcesses";
import { useViewport } from "../../hooks/others/useViewport";
import { TOP_MENU_BUTTONS_SIZE } from "../../utils/constants/viewConstants";

const SettingsWindowButton = () => {
    const disabled = useSelector(anyLongDisablingProcess);
    const dispatch = useDispatch();

    const buttonSize = useViewport(TOP_MENU_BUTTONS_SIZE);

    const onClick = () => {
        dispatch(setSettingsWindowVisible(true));
    }

    return (
        <IconButton disabled={disabled} onClick={onClick} size={buttonSize}>
            <Settings fontSize={buttonSize} />
        </IconButton>
    )
}

export default SettingsWindowButton;